/** CoStar.Api.ConsumerUserData.UserHistory.NoteType */
export var NoteType;
(function (NoteType) {
    NoteType[NoteType["UserProfile"] = 0] = "UserProfile";
    NoteType[NoteType["AdminAssignment"] = 1] = "AdminAssignment";
})(NoteType || (NoteType = {}));
